import poland from "assets/icons/flags/poland.svg";
import england from "assets/icons/flags/united-kingdom.svg";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { Locales } from "utils/types/util.types";
import { useSnackbar } from "notistack";

function LanguageSwitch() {

	const { i18n } = useTranslation();

	const { enqueueSnackbar } = useSnackbar();

	const onClick = () => {
		enqueueSnackbar(i18n.resolvedLanguage === Locales.PL ? "Switched to english language" : "Zmieniono język na polski", { variant: "success", preventDuplicate: true })
		i18n.changeLanguage(i18n.resolvedLanguage === Locales.PL ? Locales.EN : Locales.PL)
	}

	return (
		<div
			className="language-switch cursor-pointer"
			onClick={ onClick }
		>
			<div className={ classNames("language-switch__ball", { "language-switch__ball--active": i18n.resolvedLanguage !== Locales.PL }) }>
				<img src={ poland } alt="PL"/>
				<img src={ england } alt="ENG"/>
			</div>
		</div>
	);
}

export default LanguageSwitch;